import React, {useState} from 'react';
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import Tabs from '../Tabs';
import TabPanel from './TabPanel';
import _ from 'lodash';
import ReactHtmlParser from "react-html-parser";


const Container = styled.div`
    width: 100%;
    margin-block: 20px;
    // border: 1px solid red;
`;

const getTabProps = (data={}) => {
    const tabsData = [];
    for (const keyName in data) {
        if(!_.isEmpty(data[keyName]["internal_linking"]) && typeof(data[keyName]["internal_linking"]) === "object"){
            tabsData.push({
                title: _.get(data[keyName], "title", ""),
                subTitle: null,
                content: <TabPanel data={_.get(data[keyName], "internal_linking", [])} />
            })
        }
    }
    return tabsData;
    // return data?.map((datum, idx) => ({title: datum?.title || "To", subTitle: null, content: <TabPanel data={datum?.link || []} />}))
}

const TabbedLinks = ({data={}}) => {
    const [tabProps] = useState(getTabProps(data));
    if(_.isEmpty(tabProps)){
        return null;
    }
    return(
        <Container>
            <Title type="h2">{_.get(data, "title", "Popular Flights")}</Title>
            <Text>{ReactHtmlParser(_.get(data, "description", "<p>Looking for the shortest flight duration? here’s is a flight for you</p>"))}</Text>
            <Tabs scrollButtons="auto" variant="scrollable"
                tabs={getTabProps(data)} isRenderAllInitially
                // tabs={[{title:'Flights to Tokyo', subTitle: null, content: <TabPanel />}, {title:'Flights from Tokyo', subTitle: null, content: <TabPanel />}]} 
            />
        </Container>
    )
}

export default TabbedLinks;
